import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitofivejyotilingacab() {



const cardData = {
  keyword: "Mumbai to 5 Jyotirlinga Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to 5 Jyotirlinga cab services for devotees and travelers planning a spiritual journey across Maharashtra’s most revered Shiva temples. Whether you are organizing a pilgrimage tour, a family trip, or a group visit, our cab service ensures safe, convenient, and stress-free travel with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance and highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to 5 Jyotirlinga cab services.",

topPlaces: [
  {
    title: "Trimbakeshwar Jyotirlinga",
    description:
      "Trimbakeshwar Temple near Nashik is one of the twelve Jyotirlingas and holds immense spiritual significance. The temple features intricate architecture, sacred rituals, and the origin of the Godavari River. Visitors can participate in abhishekam, aarti, and explore nearby sacred sites. Traveling by cab allows devotees to reach the temple comfortably, manage their pilgrimage schedule efficiently, and experience the serene environment without worrying about local transport or parking."
  },
  {
    title: "Grishneshwar Jyotirlinga",
    description:
      "Grishneshwar Temple, located near Ellora Caves in Aurangabad, is the last of the 12 Jyotirlingas and is famed for its Maratha-style architecture and spiritual ambiance. Pilgrims can offer prayers, attend rituals, and admire the temple carvings and sculptures. A cab ride ensures convenient travel, allowing devotees to include Grishneshwar along with other Jyotirlinga sites in a smooth itinerary while avoiding transport hassles."
  },
  {
    title: "Bhimashankar Jyotirlinga",
    description:
      "Bhimashankar Temple, nestled in the Sahyadri hills, is not only a Jyotirlinga but also surrounded by Bhimashankar Wildlife Sanctuary. Visitors can enjoy both spiritual and nature experiences, participate in rituals, and explore trekking trails nearby. Traveling by cab provides a comfortable journey through hilly terrain, enabling devotees to plan their pilgrimage efficiently and enjoy both temple and wildlife sites."
  },
  {
    title: "Trimbakeshwar – Alternate Viewing / Scenic Route",
    description:
      "While on the journey to the Jyotirlingas, travelers often take scenic routes around Nashik, including vineyards, small local temples, and riverbanks, providing a more enriching pilgrimage experience. A cab allows you to stop conveniently, take photos, and enjoy the natural surroundings while maintaining the schedule of visiting multiple Jyotirlinga sites."
  },
  {
    title: "Grishneshwar – Cultural Stops Nearby",
    description:
      "Near Grishneshwar, visitors can explore cultural and historical spots like the Ellora Caves, enjoying ancient architecture and art alongside their spiritual journey. Traveling by cab allows seamless integration of these visits into the pilgrimage itinerary, providing flexibility, comfort, and a well-rounded travel experience."
  }
],

services: [
{
name: "Mumbai to 5 Jyotirlinga Cab",
description: "Mumbai to 5 Jyotirlinga cab service offers comfortable pilgrimage travel for devotees visiting the sacred Jyotirlinga temples. Our AC sedans, SUVs, and premium vehicles ensure smooth highway journeys across Maharashtra temple routes. Professional drivers are familiar with temple circuits and pilgrimage travel. Pickup is available from homes, hotels, offices, and Mumbai airport. Ideal for family pilgrimage tours and group temple visits."
},
{
name: "Mumbai to 5 Jyotirlinga Taxi",
description: "Mumbai to 5 Jyotirlinga taxi service provides reliable transportation for devotees planning the sacred Jyotirlinga pilgrimage. Comfortable AC vehicles ensure relaxed long-distance travel. Experienced drivers guide travelers safely through temple routes. Flexible pickup options are available across Mumbai."
},
{
name: "Mumbai to 5 Jyotirlinga Cab Service",
description: "Mumbai to 5 Jyotirlinga cab service is designed for pilgrims seeking convenient and comfortable temple travel. Well-maintained vehicles and trained drivers ensure smooth long-distance journeys between temples. Pickup is available from any location in Mumbai including airport terminals."
},
{
name: "Mumbai to 5 Jyotirlinga Darshan Cab",
description: "Mumbai to 5 Jyotirlinga darshan cab service provides dedicated transportation for completing the sacred temple circuit. Comfortable vehicles ensure relaxed travel between temple destinations. Professional drivers help manage temple visit schedules for smooth darshan experiences."
},
{
name: "Mumbai to Jyotirlinga Tour Cab",
description: "Mumbai to Jyotirlinga tour cab service offers complete pilgrimage travel for devotees visiting multiple Jyotirlinga temples. Spacious vehicles and experienced drivers ensure safe highway journeys. Ideal for family pilgrimage tours and group temple travel."
},
{
name: "Mumbai to Jyotirlinga Taxi Package",
description: "Mumbai to Jyotirlinga taxi package offers a complete travel solution covering temple visits, comfortable vehicles, and experienced drivers. Flexible tour plans allow devotees to complete pilgrimage journeys without travel stress."
},
{
name: "Mumbai Jyotirlinga Tour Cab Booking",
description: "Mumbai Jyotirlinga tour cab booking allows devotees to reserve vehicles easily for temple pilgrimage tours. Instant booking confirmation and flexible pickup options simplify travel planning. Sedan, SUV, and premium vehicles are available."
},
{
name: "Mumbai to Jyotirlinga Temple Cab",
description: "Mumbai to Jyotirlinga temple cab service provides comfortable transportation for devotees visiting sacred Shiva temples. AC vehicles ensure relaxed travel across long distances. Experienced drivers ensure safe travel on temple routes."
},
{
name: "Mumbai Jyotirlinga Darshan Taxi",
description: "Mumbai Jyotirlinga darshan taxi service offers convenient road travel for devotees planning temple visits. Comfortable vehicles and professional drivers ensure smooth journeys between sacred temples."
},
{
name: "Mumbai to 5 Jyotirlinga Cab Package",
description: "Mumbai to 5 Jyotirlinga cab package provides a complete pilgrimage travel plan covering major Jyotirlinga temples. Spacious vehicles, experienced drivers, and flexible schedules ensure comfortable temple tours."
},
{
name: "Mumbai to Jyotirlinga Innova Cab",
description: "Innova cab from Mumbai to Jyotirlinga temples is ideal for families and group pilgrims requiring spacious seating and luggage capacity. The premium MPV ensures comfortable long-distance temple travel."
},
{
name: "Mumbai to Jyotirlinga Ertiga Cab",
description: "Ertiga cab from Mumbai to Jyotirlinga temples provides comfortable travel for medium-size families and small groups. Spacious interiors and AC comfort ensure relaxed highway journeys."
}
],

tableData: [
["Mumbai to 5 Jyotirlinga Cab","Mumbai to 5 Jyotirlinga Taxi"],
["Mumbai to 5 Jyotirlinga Cab Service","Mumbai to 5 Jyotirlinga Darshan Cab"],
["Mumbai to Jyotirlinga Tour Cab","Mumbai to Jyotirlinga Taxi Package"],
["Mumbai Jyotirlinga Tour Cab Booking","Mumbai to Jyotirlinga Temple Cab"],
["Mumbai Jyotirlinga Darshan Taxi","Mumbai to 5 Jyotirlinga Cab Package"],
["Mumbai to Jyotirlinga Innova Cab","Mumbai to Jyotirlinga Ertiga Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Pilgrimage Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance temple tours and are familiar with all major Jyotirlinga routes including Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Their knowledge ensures a safe, well-planned, and peaceful pilgrimage journey from Mumbai."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs follows a transparent pricing structure for Mumbai to 5 Jyotirlinga cab tours. We clearly explain the full package cost, travel distance, and route details in advance so you never face hidden charges or unexpected costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Pilgrimage journeys often start early or continue overnight. Omshree Cabs operates 24/7 to provide reliable cab services for 5 Jyotirlinga tours from Mumbai with flexible departure timings."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained, fully air-conditioned vehicles suitable for long religious tours. Each vehicle is cleaned and sanitized regularly to provide a comfortable and hygienic travel experience."
  },
  {
    WhyChooseheading: "Flexible Travel Packages",
    WhyChoosedescription: "We offer customizable travel packages for the 5 Jyotirlinga tour including 2-day, 3-day, or extended pilgrimage options. Travelers can plan the route, temple visits, and stay duration according to their preferences."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, and larger vehicles for family or group pilgrimage tours. You can choose the vehicle that best suits your group size and comfort needs."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from your home, hotel, office, or airport anywhere in Mumbai. Our drivers arrive on time and start your spiritual journey without any travel hassle."
  },
  {
    WhyChooseheading: "Reliable Pilgrimage Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many devotees for Jyotirlinga pilgrimage tours. Our punctual service, safe driving, and professional approach ensure that your religious journey remains peaceful and comfortable."
  }
]
};

const faqData = [
  { question: "Which Jyotirlinga temples are included in the 5 Jyotirlinga tour from Mumbai?", answer: "The common 5 Jyotirlinga tour includes Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath temples." },
  { question: "How many days are required for the 5 Jyotirlinga tour?", answer: "Most travelers complete the 5 Jyotirlinga tour in 2–3 days depending on the travel route and temple visit schedule." },
  { question: "Do you provide complete 5 Jyotirlinga cab packages?", answer: "Yes, Omshree Cabs offers complete cab packages covering all five Jyotirlinga temples starting from Mumbai." },
  { question: "Which vehicles are available for the pilgrimage trip?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and larger vehicles depending on your group size and comfort preferences." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Jyotirlinga pilgrimage bookings." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, every vehicle provided by Omshree Cabs is fully air-conditioned for comfortable long-distance travel." },
  { question: "Can we customize the temple visit schedule?", answer: "Yes, travelers can customize the temple route, travel plan, and stop locations according to their convenience." },
  { question: "Do drivers know all Jyotirlinga temple locations?", answer: "Yes, our drivers are experienced with all Jyotirlinga routes and temple locations." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during religious festivals, Shravan month, and holiday seasons." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sanjay Deshpande",
    feedback:
      "We booked Omshree Cabs for the 5 Jyotirlinga pilgrimage from Mumbai. The driver knew all temple routes very well and the journey was smooth and comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meena Patil",
    feedback:
      "Our family completed the 5 Jyotirlinga tour with Omshree Cabs. Clean vehicle, professional driver, and very well-planned travel. Highly recommended for pilgrimage trips.",
    rating: 5
  }
];























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to 5 Jyotirlinga Cab",
  "description": "Book Mumbai to 5 Jyotirlinga Cab with Omshree Cab for comfortable Jyotirlinga temple darshan tours. Reliable taxi service with Innova, Ertiga, and other cabs for Jyotirlinga temple visits. Affordable cab packages, easy booking, and safe travel for your Mumbai Jyotirlinga tour.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1750"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Mumbai to 5 Jyotirlinga Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to 5 Jyotirlinga Cab with Omshree Cab for temple darshan tours. Taxi packages with Innova and Ertiga cabs for Jyotirlinga temple visits. Affordable fares, safe travel, and easy cab booking for Mumbai Jyotirlinga tour." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/106.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitofivejyotilingacab;